import { render, staticRenderFns } from "./BannerForm.vue?vue&type=template&id=10bc9b90&scoped=true"
import script from "./BannerForm.vue?vue&type=script&lang=ts"
export * from "./BannerForm.vue?vue&type=script&lang=ts"
import style0 from "./BannerForm.vue?vue&type=style&index=0&id=10bc9b90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bc9b90",
  null
  
)

export default component.exports